import React from 'react';
import Modal from '~/components/ModalNewVehicle';
import { ContainerModal, TitleModal, Divider } from '../../../MapOpportunities/styles';
import InfoPanel from '../../../MapOpportunities/components/MapModalSections/InfoPanel';
import NameValueItem from '../../../MapOpportunities/components/MapModalSections/NameValueItem';
import { SimovsatVehicleAPI } from '~/types';

interface VehicleDetailsProps {
  vehicle: SimovsatVehicleAPI;
  open: boolean;
  onClose: () => void;
}

const VehicleDetails: React.FC<VehicleDetailsProps> = ({ vehicle, open, onClose }) => {
  const formatDate = (dateString: string) => {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return dateString;
    }
  };

  return (
    <Modal
      onConfirm={onClose}
      onCancel={onClose}
      open={open}
      question={false}
      buttonPositive='Fechar'
    >
      <ContainerModal>
        <TitleModal>Detalhes do Veículo</TitleModal>
        <Divider height={15} />

        <InfoPanel title='Informações Básicas'>
          <NameValueItem title='ID'>{vehicle.id || 'N/A'}</NameValueItem>
          <NameValueItem title='Placa'>{vehicle.license_plate || 'N/A'}</NameValueItem>
          <NameValueItem title='Modelo'>{vehicle.model || 'N/A'}</NameValueItem>
          <NameValueItem title='Cor'>{vehicle.color || 'N/A'}</NameValueItem>
          <NameValueItem title='Fabricante'>{vehicle.manufacture || 'N/A'}</NameValueItem>
          <NameValueItem title='Ano'>{vehicle.model_year || 'N/A'}</NameValueItem>
          <NameValueItem title='Status'>{vehicle.status === 'ATIVO' ? 'Ativo' : 'Inativo'}</NameValueItem>
        </InfoPanel>

        <InfoPanel title='Localização'>
          <NameValueItem title='Estado'>{vehicle.state || 'N/A'}</NameValueItem>
          <NameValueItem title='Cidade'>{vehicle.city || 'N/A'}</NameValueItem>
        </InfoPanel>

        <InfoPanel title='Identificação'>
          <NameValueItem title='VIN/Chassi'>{vehicle.vin || 'N/A'}</NameValueItem>
          <NameValueItem title='ID Organização'>{vehicle.association_id || 'N/A'}</NameValueItem>
          <NameValueItem title='ID Cliente'>{vehicle.customer_id || 'N/A'}</NameValueItem>
          <NameValueItem title='ID Tipo de Veículo'>{vehicle.vehicle_customer_type_id || 'N/A'}</NameValueItem>
        </InfoPanel>

        <InfoPanel title='Informações Adicionais'>
          <NameValueItem title='Criado em'>{formatDate(vehicle.created_at)}</NameValueItem>
          <NameValueItem title='Atualizado em'>{formatDate(vehicle.updated_at)}</NameValueItem>
          {vehicle.fipe_data && (
            <NameValueItem title='Dados FIPE'>
              <pre style={{ fontSize: '12px', margin: 0 }}>
                {JSON.stringify(vehicle.fipe_data, null, 2)}
              </pre>
            </NameValueItem>
          )}
        </InfoPanel>
      </ContainerModal>
    </Modal>
  );
};

export default VehicleDetails;
